import React from 'react';

const Company = () => {
  return (
    <div className="container mx-auto px-4 py-12 sm:px-6 lg:px-8">
      <section className="mb-20">
        <h1 className="text-4xl font-bold text-center mb-12">About Ancile</h1>
        <div className="max-w-3xl mx-auto text-lg text-gray-700 space-y-6">
          <h2 className="text-2xl font-bold">Mission</h2>
          <p>
            To empower organizations with complete, real-time visibility and control over their sensitive data—across every environment—so they can stay secure, compliant, and confident in a dynamic digital world.
          </p>
          
          <h2 className="text-2xl font-bold mt-8">Vision</h2>
          <p>
            To be the trusted global leader in Data Security Posture Management by driving innovation, automation, and transparency—making data security smarter, simpler, and future-ready for every enterprise.
          </p>
          
          <h2 className="text-2xl font-bold mt-8">About Us</h2>
          <p>
            Ancile is a technology-first company focused on transforming how businesses secure and manage their data. Our Data Security Posture Management (DSPM) platform delivers intelligent, automated insights into data risks, exposures, and compliance gaps across multi-cloud. Built with modern architectures, explainable AI, and deep integration with platforms like AWS and Azure, we help security teams stay ahead of threats while simplifying their workflows.
          </p>
        </div>
      </section>

      <section className="mb-20">
        <h2 className="text-3xl font-bold text-center mb-12">Leadership</h2>
        <div className="max-w-3xl mx-auto text-lg text-gray-700 mb-8">
          <p>Driven by vision, experience, and innovation—our leadership team is shaping the future of data security.</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
          {/* Team Member 1 */}
          <div className="text-center">
            <div className="w-40 h-40 rounded-full overflow-hidden mx-auto mb-4">
              <img src="/assets/images/han.jpeg" alt="Team member" className="w-full h-full object-cover" />
            </div>
            <h3 className="text-xl font-semibold">Han Kanthi</h3>
            <p className="text-gray-600">Founder</p>
            <a href="https://www.linkedin.com/in/kanthi/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-blue-600 hover:text-blue-800 mt-2">
              <svg className="w-5 h-5 mr-1" fill="currentColor" viewBox="0 0 24 24">
                <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
              </svg>
              LinkedIn
            </a>
          </div>

          {/* Team Member 2 */}
          <div className="text-center">
            <div className="w-40 h-40 rounded-full overflow-hidden mx-auto mb-4">
              <img src="/assets/images/karna.jpeg" alt="Team member" className="w-full h-full object-cover" />
            </div>
            <h3 className="text-xl font-semibold">Karna Bojjireddy</h3>
            <p className="text-gray-600">Board of Advisor</p>
            <a href="https://www.linkedin.com/in/karunakar-bojjireddy-03b77a1/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-blue-600 hover:text-blue-800 mt-2">
              <svg className="w-5 h-5 mr-1" fill="currentColor" viewBox="0 0 24 24">
                <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
              </svg>
              LinkedIn
            </a>
          </div>

        </div>
      </section>

    </div>
  );
};

export default Company; 